import sensors from 'sa-sdk-javascript';
import { Env, getEnv } from './env';

const serverConfig = {
    [Env.dev]: {
        server: 'https://sensors.nio.com/sa',
        project: 'nioapp_test'
    },
    [Env.test]: {
        server: 'https://sensors.nio.com/sa',
        project: 'nioapp_test'
    },
    [Env.stg]: {
        server: 'https://sensors.nio.com/sa',
        project: 'nioapp_test'
    },
    [Env.prod]: {
        server: 'https://sensors.nio.com/sa',
        project: 'nioapp_prod'
    }
};

export function initSensor() {
    const env = getEnv();
    console.log(env);

    const { server, project } = serverConfig[env];

    try {
        sensors.init({
            server_url: `${server}?project=${project}`,
            app_js_bridge: true
        });

        sensors.setProfile({
            app_version: encodeURIComponent('0.0.1'),
            app_env: env
        });
        window.sensors = sensors;
    } catch (e) {
        console.error('init sa error', e);
    }
}



// WEBPACK FOOTER //
// ./src/util/sensor.js